'use strict';

var moment = require('moment');

var userDateFormat = 'DD/MM/YYYY';
var serverDateFormat = 'YYYY-MM-DD';
var benefitsDateFormat = 'DDMMYYYY';
var userDateFormatRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
var serverDateFormatRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
var benefitsDateFormatRegex = /^(\d{2})(\d{2})(\d{4})$/;

function getDate(date) {
    if (date instanceof Date) {
        return date;
    }
    if (typeof date === 'string') {
        var res = userDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[3], res[2] - 1, res[1]);
        }
        res = serverDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[1], res[2] - 1, res[3]);
        }
        res = benefitsDateFormatRegex.exec(date);
        if (res) {
            return new Date(res[3], res[2] - 1, res[1]);
        }
    }
    if (typeof date === 'number') {
        return new Date(date);
    }
    return '';
}

function format2server(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + y + '-' + m + '-' + d;
    }
    return '';
}

function format2user(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + d + '/' + m + '/' + y;
    }
    return '';
}

function format4benefits(date) {
    var dt = getDate(date);
    if (dt) {
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        return '' + d + m + y;
    }
    return '';
}

function getDaysTotal(date) {
    var dt = getDate(date);
    if (dt) {
        var days = dt / (1000 * 60 * 60 * 24);
        return Math.ceil(days);
    }
    return 0;
}

function getYearsTotal(date) {
    var dt = getDate(date);
    if (dt) {
        var diffMs = Date.now() - dt.getTime();
        var ageDate = new Date(diffMs);
        return Math.abs(ageDate.getFullYear() - 1970);
    }
    return 0;
}

function getDaysFromNow(date) {
    var firstDate = moment(date, 'DD/MM/YYYY').startOf('day');
    var todayDate = moment(new Date()).startOf('day');

    if(firstDate){
        return firstDate.diff(todayDate, 'days');
    }

    return 0;
}

function dateIsBetween(startDate, endDate, checkDate) {
    var startDays = getDaysTotal(startDate);
    var endDays = getDaysTotal(endDate);
    var checkDays = getDaysTotal(checkDate);
    return startDays <= checkDays && checkDays <= endDays;
}

function isSameDate(date1, date2) {
    return getDaysTotal(date1) === getDaysTotal(date2);
}

function isAdult(date) {
    return 18 <= getYearsTotal(date);
}
/*
 * Param - Date object
 * Return - Date string in DD-MM-YYYY format
 * Also prepend 0s if not present on day or month
  * */
function dateFormatDayMonthYear(date) {
    var d = new Date(date);
    var month = String(d.getMonth() + 1);
    var day = String(d.getDate());
    var year = String(d.getFullYear());

    if (month.length < 2) {month = '0' + month;}
    if (day.length < 2) {day = '0' + day;}

    return day+'/'+month+'/'+year;
}

module.exports = {
    serverDateFormat: serverDateFormat,
    userDateFormat: userDateFormat,
    benefitsDateFormat: benefitsDateFormat,
    userDateFormatRegex: userDateFormatRegex,
    serverDateFormatRegex: serverDateFormatRegex,
    benefitsDateFormatRegex: benefitsDateFormatRegex,
    getDate: getDate,
    format2server: format2server,
    format2user: format2user,
    format4benefits: format4benefits,
    getDaysTotal: getDaysTotal,
    getYearsTotal: getYearsTotal,
    getDaysFromNow: getDaysFromNow,
    dateIsBetween: dateIsBetween,
    isSameDate: isSameDate,
    isAdult: isAdult,
    dateFormatDayMonthYear: dateFormatDayMonthYear
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/dateUtils.js
// module id = lglL
// module chunks = 0 1 2 3 4